export default __webpack_public_path__ + "static/media/chev-right-white.67f8f203.svg";